//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ViewBox, XHeader, Group, Cell, XButton } from 'vux'

export default {
  name: 'detail',
  data () {
    return {
      user: {}
    }
  },
  methods: {
    click () {
      if (this.user.friendly) {
        // 跳转到chat界面
        this.$router.replace({
          name: 'chat',
          query: {
            mode: 'push',
            title: this.user.username
          }
        })
      } else {
        this.$addFriend(this.user.username, err => {
          if (err) {
            console.log(err)
            return
          }

          // 发送请求成功
          console.log('发送请求成功')
          this.$completed('已发送添加好友请求')
        })
      }
    }
  },
  mounted () {
    // 获取用户信息列表
    const username = this.$route.query.username
    this.$search(username, (err, user) => {
      if (err) {
        console.log(err)
        return
      }

      this.user = user
    })
  },
  components: {
    ViewBox,
    XHeader,
    Group,
    Cell,
    XButton
  }
}
